import store from '@/store'
import i18n from '@/libs/i18n'
import {computed, ref, watch} from "@vue/composition-api"
import {ReportState} from "@/views/main/reports/utils"

export default function useUsageReport() {
    const state = ref(ReportState.SUCCESS)
    const reportTable = ref(null)
    const totalItems = ref(0)

    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)

    const dateRange = ref([yesterday, new Date()])
    const customerId = ref("")
    const currentPage = ref(1)
    const perPage = ref(50)

    const tableColumns = [
        {key: 'identifier', label: i18n.t('Identifier')},
        {key: 'lowerHourmeterDate', label: i18n.t('Lower Hourmeter Date')},
        {key: 'lowerHourmeter', label: i18n.t('Lower Hourmeter')},
        {key: 'lowerHourmeterBDate', label: i18n.t('Lower Hourmeter B Date')},
        {key: 'lowerHourmeterB', label: i18n.t('Lower Hourmeter B')},
        {key: 'lowerHodometerDate', label: i18n.t('Lower Hodometer Date')},
        {key: 'lowerHodometer', label: i18n.t('Lower Hodometer')},
        {key: 'upperHourmeterDate', label: i18n.t('Upper Hourmeter Date')},
        {key: 'upperHourmeter', label: i18n.t('Upper Hourmeter')},
        {key: 'upperHourmeterBDate', label: i18n.t('Upper Hourmeter B Date')},
        {key: 'upperHourmeterB', label: i18n.t('Upper Hourmeter B')},
        {key: 'upperHodometerDate', label: i18n.t('Upper Hodometer Date')},
        {key: 'upperHodometer', label: i18n.t('Upper Hodometer')},
        {key: 'hourmeterDifference', label: i18n.t('Hourmeter Difference')},
        {key: 'hourmeterBDifference', label: i18n.t('Hourmeter B Difference')},
        {key: 'hodometerDifference', label: i18n.t('Hodometer Difference')},
    ]

    const metadata = computed(() => {
        const localItemsCount = reportTable.value ? reportTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalItems.value,
        }
    })

    watch([currentPage, perPage, customerId], () => reportTable.value.refresh())

    const formatDate = date => {
        const month = String(date.getMonth() + 1)
        const formattedMonth = month.length === 1 ? '0' + month : month

        return `${date.getDate()}/${formattedMonth}/${date.getFullYear()}`;
    }

    const fetchUsageDetails = (_, callback) => {
        state.value = ReportState.LOADING
        // const dates = typeof dateRange.value === "string"
        //     ? dateRange.value.split(" to ")
        //     : dateRange.value.map(date => formatDate(date))

        const dates = ref([]);

        if (typeof dateRange.value === "string") {
            dates.value = dateRange.value.includes('to') ?  dateRange.value.split(" to ") : [dateRange.value, dateRange.value]
        } else {
            dates.value = dateRange.value.map(date => formatDate(date));
        }

        store.dispatch("reports/fetchUsageDetails", {
            startDate: dates.value[0],
            endDate: dates.value[1],
            customerId: customerId.value,
            page: currentPage.value,
            perPage: perPage.value,
        }).then(response => {
            state.value = ReportState.SUCCESS
            totalItems.value = response.data.totalItems

            const report = response.data.data
            callback(report)
        }).catch(err => {
            state.value = ReportState.FAILURE
            callback()
        })
    }

    return {
        fetchUsageDetails,
        dateRange,
        customerId,
        currentPage,
        perPage,
        reportTable,
        totalItems,
        tableColumns,
        formatDate,
        state,
        metadata
    }
}